import { ScheduledShell } from './ScheduledTab';

/**
 * Spot Orders dashboard — sibling of Scheduled Dashboards but scoped to
 * one-off / non-scheduling-agreement POs (ERP order type 1). Reuses the
 * same KPI shell so the visual language stays consistent.
 *
 * The Forecast sub-tab is hidden because spot orders have no firm-window
 * concept (PartScheduleEntry.schedule_firm only applies to scheduling
 * agreements).
 */
export function SpotOrdersTab() {
  return (
    <ScheduledShell
      erpOrderType="1"
      scopeNotice="Showing spot / one-off orders only. Scheduling-agreement orders are on the Scheduled Dashboards tab."
      loadingLabel="Loading spot-order KPIs…"
      showForecast={false}
    />
  );
}
